import FieldsTranslation from "graphql/fields/FieldsTranslation";

export default `
	guid
	updated_at
	name
	position
	available_for
	active
	
	translations {
		${FieldsTranslation}
	}
`;
